export default "__VITE_ASSET__BIa1n34R__"